import { queryOptions } from '@tanstack/react-query';
import { api, apiUrl, call } from '@/lib/api';
import { qk } from '@/lib/query-keys';

// Accès à `/api/v1/calibration` (`api.md` § Tableau de bord et calibration, fiche T29). L'export
// CSV n'est pas servi par le client typé (`text/csv`) : le lien est un `<a href>` natif qui porte
// le cookie de session.

export type CalibrationData = Awaited<ReturnType<typeof getCalibration>>;

export function getCalibration() {
  return call(api.calibration.$get());
}

export const calibrationQueryOptions = () =>
  queryOptions({ queryKey: qk.calibration, queryFn: getCalibration });

/** URL absolue de l'export CSV des analyses annotées. */
export function analysesCsvUrl(): string {
  return apiUrl('/calibration/analyses.csv');
}
